import { render, staticRenderFns } from "./SelectWhatsAppTemplate.vue?vue&type=template&id=013acd31&scoped=true"
import script from "./SelectWhatsAppTemplate.vue?vue&type=script&lang=js"
export * from "./SelectWhatsAppTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectWhatsAppTemplate.vue?vue&type=style&index=0&id=013acd31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013acd31",
  null
  
)

export default component.exports